import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import UserContext from "./context/userContext";
import PageLoading from "./components/Globo/PageLoading/PageLoading";
import Header from "./components/Header/Header";

const PrivateRoute = ({
  requiredPermissions,
  requiredRoles,
  hideHeader,
  children,
}) => {
  const { me, hasPermission } = useContext(UserContext);

  if (me.loading) return <PageLoading />;

  if (
    requiredPermissions?.length &&
    !hasPermission({
      required: requiredPermissions,
    })
  ) {
    return <Navigate to="/acesso-negado" replace />;
  }

  if (
    requiredRoles?.length &&
    !requiredRoles.some((role) => me.user?.roles?.includes(role))
  ) {
    return <Navigate to="/acesso-negado" replace />;
  }

  return (
    <>
      {!hideHeader && <Header />}
      {children}
    </>
  );
};

export default PrivateRoute;
